import { memo, useState } from 'react';
import { FlexBox } from '@dfl/mui-react-common';
import { Chip, Popover, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FmdGoodOutlined } from '@mui/icons-material';

type Props = {
  value: string[]
};

const SpecialOfferRegionCell = ({ value }: Props) => {
  const { t } = useTranslation('collection');
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const hiddenRegions = value?.slice(2) ?? [];

  return (
    <>
      <FlexBox gap={1} alignItems='center' flexWrap='wrap'>
        {value?.slice(0, 2)?.map((region: string) => (
          <Chip
            key={region}
            icon={<FmdGoodOutlined fontSize='small' />}
            label={<div className='pt-[2px]'>{t(region)}</div>}
            sx={{ px: 0.5 }}
          />
        ))}

        {hiddenRegions?.length > 0 && (
          <Chip
            clickable
            label={`+${hiddenRegions?.length}`}
            onClick={(e) => { setAnchorEl(e.currentTarget); }}
            sx={{ px: 0.5, '&: hover': { color: 'primary.main' } }}
          />
        )}
      </FlexBox>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => { setAnchorEl(null); }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Stack p={1} gap={1}>
          {hiddenRegions.map((region: string) => (
            <Chip
              key={region}
              icon={<FmdGoodOutlined fontSize='small' />}
              label={<div className='pt-[2px]'>{t(region)}</div>}
            />
          ))}
        </Stack>
      </Popover>
    </>
  );
};

export default memo(SpecialOfferRegionCell);
